import { useState, useEffect } from "react";
import { LOGO_URL } from "@/lib/services";

const NAV = [
  { label: "Services", href: "#services" },
  { label: "About", href: "#about" },
  { label: "Contact", href: "#contact" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-50 bg-white border-b-2 border-black transition-shadow ${
        scrolled ? "shadow-[0_4px_0_0_#000]" : ""
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-20 flex items-center justify-between">
        <a href="#top" data-testid="header-logo" className="flex items-center gap-3">
          <img src={LOGO_URL} alt="StottTech" className="h-12 w-auto object-contain" />
        </a>
        <nav className="hidden md:flex items-center gap-8">
          {NAV.map((n) => (
            <a
              key={n.label}
              href={n.href}
              data-testid={`nav-${n.label.toLowerCase()}`}
              className="font-heading font-bold uppercase text-sm tracking-wide hover:text-[#E60000] transition-colors"
            >
              {n.label}
            </a>
          ))}
        </nav>
        <a
          href="#contact"
          data-testid="header-enquire-btn"
          className="bg-[#E60000] text-white font-heading font-bold uppercase text-sm tracking-wide px-5 py-2.5 border-2 border-black hover:-translate-x-0.5 hover:-translate-y-0.5 hover:shadow-[4px_4px_0_0_#000] transition-all"
        >
          Enquire Now
        </a>
      </div>
    </header>
  );
};
